import { Button, ButtonVariantEnum, Modal } from '@Wonder-Cave/ui';

interface ICampaignPriorityModalProps {
  isPrioritized: boolean;
  showModal: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onCancel: () => void;
}

const CampaignPriorityModal = ({
  isPrioritized,
  showModal,
  onClose,
  onSuccess,
  onCancel,
}: ICampaignPriorityModalProps) => {
  return (
    <Modal title="Are you sure?" show={showModal} onClose={onClose}>
      <h3 className="px-8 text-center">
        {isPrioritized
          ? 'This campaign will return to the default sending priority.'
          : 'This campaign will be elevated above default-priority campaigns in the sending pipes.'}
      </h3>
      <div className="flex justify-center mt-8 mb-4">
        <Button variant={ButtonVariantEnum.SECONDARY} onClick={onCancel} className="mr-4 uppercase">
          CANCEL
        </Button>
        <Button onClick={onSuccess} variant={ButtonVariantEnum.PRIMARY} className="uppercase">
          {isPrioritized ? 'DE-PRIORITIZE' : 'PRIORITIZE'}
        </Button>
      </div>
    </Modal>
  );
};

export default CampaignPriorityModal;
